class BaseCartItemRenderer {
	/**
	 * Set an optional validator
	 *
	 * @param {CheckoutItemsValidator} validator
	 */
	setValidator(validator) {
		this.validator = validator;
		return this;
	}

	/**
	 * Check if renderer has validator
	 *
	 * @returns {boolean}
	 */
	hasValidator() {
		return !!this.validator;
	}

	/**
	 * Set an optional cartStorage
	 *
	 * @param {CartStorage} cart
	 */
	setCartStorage(cart) {
		this.cart = cart;
		return this;
	}

	/**
	 * Check if renderer has cart storage
	 *
	 * @returns {boolean}
	 */
	hasCartStorage() {
		return !!this.cart;
	}

	/**
	 * Begin rendering based on provided validator and cart data.
	 */
	begin() {}

	/**
	 * Render items
	 */
	renderItems() {}

	/**
	 * Render one item
	 */
	renderSingleItem() {}
}

export default BaseCartItemRenderer;
